import React from "react";
import { useApiClient } from "../../../../api";
import { AnswerReview } from "./AnswerReview";

export const AnswerEditor = (props) => {
  const ApiClient = useApiClient();
  return <AnswerReview {...props} ApiClient={ApiClient} />;
};
